import { memo, ReactNode } from "react";
import { ConfirmationProvider, FullscreenLoaderProvider, PopperPortal, SnackbarProvider } from "../ui";

export type MimicContextProviderProps = {
  children: ReactNode | ReactNode []
}

export const MimicContextProvider = memo<MimicContextProviderProps>(({ children }) => {
  return (
    <PopperPortal>
      <FullscreenLoaderProvider>
        <SnackbarProvider>
          <ConfirmationProvider>
            {children}
          </ConfirmationProvider>
        </SnackbarProvider>
      </FullscreenLoaderProvider>
    </PopperPortal>
  );
});

export default MimicContextProvider;
